import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers, images } from "../data/landing";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 4500);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 12000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-39" data-mp="1657gmrp6n7tf">
      <AnimatePresence data-id="element-40" data-mp="1164kjwr6kbxl">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-2xl" data-id="element-41" data-mp="1fwbx5vuib0qd">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-brandsoft object-contain" data-id="element-42" data-mp="x6m4beab0p13" />
            <div className="min-w-0" data-id="element-43" data-mp="s8kjantbifmz">
              <p className="text-sm leading-snug text-ink" data-id="element-44" data-mp="28joi61l0r0hk">
                <span className="font-bold" data-id="element-45" data-mp="28mara5nk5o1w">{buyer.name}</span> from <span className="font-bold" data-id="element-46" data-mp="23kbp2z3k0x6j">{buyer.country}</span> just purchased the digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-47" data-mp="2ao1mavp2hlop">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="2fmd0tjqb4kd9" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors hover:bg-cream hover:text-ink" data-id="element-49" data-mp="2pmdil18j2sfc">
              <XIcon className="h-4 w-4" data-id="element-50" data-mp="21w9eksrfgqnt" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}